export const state = () => ({
    selectAgent: {},
    Result:'',
    editAgent:{},
})
